import { Component } from '@angular/core';

@Component({
    selector: 'app-create-questionnaire-template',
    templateUrl: './create-questionnaire-template.component.html',
    styleUrl: './create-questionnaire-template.component.scss',
    standalone: false
})
export class CreateQuestionnaireTemplateComponent {
  steps = ['Template details', 'Chapters & Questions', 'Summary'];

	step = 1;
  currentStep = 0;
	submitted = false;
	spinner = false;
	editMode = false;

	template_name!: string;
	description!: string;

	backStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

	nextStep() {
		this.submitted = true;
		this.currentStep++;
  }
}
